import { render, staticRenderFns } from "./iframe-active.vue?vue&type=template&id=de151b1c&scoped=true"
import script from "./iframe-active.vue?vue&type=script&lang=js"
export * from "./iframe-active.vue?vue&type=script&lang=js"
import style0 from "./iframe-active.vue?vue&type=style&index=0&id=de151b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de151b1c",
  null
  
)

export default component.exports